export function logout(url: string): void {
	const BASE_URL = "HITIT_BACKEND_URL";
	localStorage.clear();
	sessionStorage.clear();
	window.location.assign(url);
}